import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TKyoriWarimasiTarihuGetListReq,
  TKyoriWarimasiTarihuGetListRes,
  TKyoriWarimasiTarihuPutReq,
  TKyoriWarimasiTarihuListInfoGetRes,
} from "./TKyoriWarimasiTarihu"

/**
 * 距離割増タリフに対するAPIリクエスト用サービス
 *
 * @export
 * @class KyoriWarimasiTarihuService
 * @extends {ConnectApi}
 */
export default class KyoriWarimasiTarihuService extends ConnectApi {
  /**
   * 一覧取得
   */
  getListInfo = async () => {
    try {
      return {
        data: 一覧dummy,
      }
    } catch (err) {
      throw err
    }
  }

  /**
   * 距離割増タリフ 一覧取得
   *
   * @param {TKyoriWarimasiTarihuGetListReq} params
   * @param {(param: TApiResponse<TKyoriWarimasiTarihuGetListRes>) => any} resolve
   * @param {(param: TApiResponse<TKyoriWarimasiTarihuGetListRes>) => any} reject
   * @memberof KyoriWarimasiTarihuService
   */
  getList = async (params: TKyoriWarimasiTarihuGetListReq) => {
    try {
      // const res: AxiosResponse<TApiResponse<TZyomuinListGetRes>> =
      // await this.getInner(`/master/hinmei`, params)
      //return res.data
      //   if (params.年月 === "2" && params.品コード === "1") {
      //     // eslint-disable-next-line no-throw-literal
      //     throw "ERROR"
      //   }

      // TODO:データあり、なし
      if (params.荷主コード) {
        return {
          data: 距離割増タリフ一覧dummyList_1,
        }
      } else {
        return {
          data: 距離割増タリフ一覧dummyList_2,
        }
      }

      //TODO: api実装必要
    } catch (err) {
      throw err
    }
  }

  /**
   * 距離割増タリフ 更新
   *
   * @param {TKyoriWarimasiTarihuPutReq} data
   * @param {(param: TApiResponse<TKyoriWarimasiTarihuGetListRes[]>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TKyoriWarimasiTarihuGetListRes[]>>) => any} reject
   * @memberof KyoriWarimasiTarihuService
   */
  put = async (data: TKyoriWarimasiTarihuPutReq[]) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `billing/KyoriWarimasitarihu/register`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}

//TODO:ダミーデータ
const 一覧dummy: TKyoriWarimasiTarihuListInfoGetRes[] = [
  {
    荷主ID: 1,
    荷主コード: "100001",
    荷主名: "アーステック株式会社",
  },
  {
    荷主ID: 2,
    荷主コード: "100002",
    荷主名: "アサヒロジ株式会社",
  },
]

const 距離割増タリフ一覧dummyList_1: TKyoriWarimasiTarihuGetListRes = {
  荷主ID: 1,
  距離割増タリフ明細: [
    {
      距離割増タリフid: 1,
      適用開始日: "2022-01-01T00:00:00",
      単価距離: 1000,
      単価積卸回数加算: 1500,
      単価日祝加算: 10000,
      単価時間外加算: 10500,
      備考: "test1",
      更新日時: "2022-01-01T00:00:00",
      modifyToken: "2022-02-01T00:00:00",
    },
    {
      距離割増タリフid: 2,
      適用開始日: "2022-02-21T00:00:00",
      単価距離: 10000,
      単価積卸回数加算: 22500,
      単価日祝加算: 10123,
      単価時間外加算: 30500,
      備考: "test2",
      更新日時: "2022-01-01T00:00:00",
      modifyToken: "2022-02-01T00:00:00",
    },
  ],
  更新日時: "2022-01-01T00:00:00",
  modifyToken: "2022-02-01T00:00:00",
}

const 距離割増タリフ一覧dummyList_2: TKyoriWarimasiTarihuGetListRes = {
  荷主ID: 2,
  距離割増タリフ明細: [
    {
      距離割増タリフid: undefined,
      適用開始日: "",
      単価距離: 0,
      単価積卸回数加算: 0,
      単価日祝加算: 0,
      単価時間外加算: 0,
      備考: "",
      更新日時: "",
      modifyToken: "2022-02-01T00:00:00",
    },
  ],
  更新日時: "2022-01-01T00:00:00",
  modifyToken: "2022-02-01T00:00:00",
}
